import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction";
import { FluentProvider } from "@/dependencies";
import {
  makeStyles,
  ToolbarButton,
  ToolbarButtonProps,
} from "@fluentui/react-components";

interface ToolbarButtonCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
}

const useStyles = makeStyles({
  root: {
    fontWeight: "normal",
    //padding: "0px 8px"
  },
});

const ToolbarButtonCustom = (
  props: ToolbarButtonCustomProps & ToolbarButtonProps,
) => {
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles,
  );
  const styles = useStyles();
  return isCanBeVisible ? (
    props.theme ? (
      <FluentProvider theme={props.theme}>
        <ToolbarButton className={styles.root} {...props} />
      </FluentProvider>
    ) : (
      <ToolbarButton className={styles.root} {...props} />
    )
  ) : null;
};

export default ToolbarButtonCustom;
